import { render } from "./RegistrationEdstack.vue?vue&type=template&id=b45b197c&scoped=true"
import script from "./RegistrationEdstack.vue?vue&type=script&lang=js"
export * from "./RegistrationEdstack.vue?vue&type=script&lang=js"

import "./RegistrationEdstack.vue?vue&type=style&index=0&id=b45b197c&scoped=true&lang=css"
import "./RegistrationEdstack.vue?vue&type=style&index=1&id=b45b197c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b45b197c"]])

export default __exports__